import { zipCodeRegexUS } from "../../../../utils/validation/zip-code.ts"
import type { Project } from "../../types/project.types.ts"
import { projectCustomerRecord } from "./project-overview-customer.ts"

interface AddressLike {
  address: string | null
  address_2: string | null
  city: string | null
  state: string | null
  zip_code: string | null
}

const addressValues = (address: AddressLike | null): AddressLike => ({
  address: address?.address ?? null,
  address_2: address?.address_2 ?? null,
  city: address?.city ?? null,
  state: address?.state ?? null,
  zip_code: address?.zip_code ?? null
})

const projectCustomerAddressValues = (project?: Project | null): AddressLike =>
  addressValues(projectCustomerRecord(project))

const projectPropertyAddressValues = (project?: Project | null): AddressLike =>
  addressValues(project ?? null)

/** Mirrors the existing form's own rule: a linked, already-Active customer's
 * address is locked from here too, the same as on the Address tab today. */
const isCustomerAddressLocked = (project?: Project | null): boolean =>
  projectCustomerRecord(project)?.status === "Active"

const addressLine = (address: AddressLike | null): string | null =>
  [address?.address, address?.address_2, address?.city, address?.state, address?.zip_code]
    .filter(Boolean)
    .join(", ") || null

const customerAddressLine = (project?: Project | null): string | null =>
  addressLine(projectCustomerRecord(project))

const propertyAddressLine = (project?: Project | null): string | null =>
  addressLine(project ?? null)

/** Mirrors the exact rule the existing property/customer map previews use. */
const projectMapAddress = (address: AddressLike | null): string | null => {
  const city = address?.city?.trim()
  const state = address?.state?.trim()
  if (!city || !state) return null

  const zip = address?.zip_code?.trim().toUpperCase()
  const parts = [
    address?.address?.trim(),
    city,
    state,
    zip && zipCodeRegexUS.test(zip) ? zip : null
  ].filter(Boolean)

  return `${parts.join(", ")}, USA`
}

export {
  type AddressLike,
  addressLine,
  customerAddressLine,
  propertyAddressLine,
  projectMapAddress,
  projectCustomerAddressValues,
  projectPropertyAddressValues,
  isCustomerAddressLocked
}
